import React from 'react';
import { FC } from 'react';

export const EyeDropEmpty: FC<{}> = () => (
    <svg viewBox='0 0 41 24' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_24_110)'>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M0 4C0 1.79086 1.79086 0 4 0H37C39.2091 0 41 1.79086 41 4V20C41 22.2091 39.2091 24 37 24H4C1.79086 24 0 22.2091 0 20V4ZM4 1H37C38.6569 1 40 2.34315 40 4V20C40 20.5423 39.8561 21.051 39.6044 21.49L2.04688 1.7228C2.57169 1.27225 3.25406 1 4 1ZM1.39557 2.51006C1.14389 2.94904 1 3.45771 1 4V20C1 21.6569 2.34314 23 4 23H37C37.7459 23 38.4283 22.7278 38.9531 22.2772L1.39557 2.51006Z'
                fill='#DE1C22'
            />
        </g>
        <defs>
            <clipPath id='clip0_24_110'>
                <rect width='41' height='24' />
            </clipPath>
        </defs>
    </svg>
);
